import { render, staticRenderFns } from "./Syndic.vue?vue&type=template&id=44decd49&scoped=true"
import script from "./Syndic.vue?vue&type=script&lang=js"
export * from "./Syndic.vue?vue&type=script&lang=js"
import style0 from "./Syndic.vue?vue&type=style&index=0&id=44decd49&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44decd49",
  null
  
)

export default component.exports